const apiKentico = "https://deliver.kenticocloud.com/010f24d6-49bf-4ff0-a1a8-ba951cc97376/items";
const objPreview = {};

//pages
const apiHome = "?system.codename=home_page&limit=1";
const apiWork = "?system.codename=work_page&limit=1";
const apiWord = "?system.codename=words_page&limit=1";
const apiMarket = "?system.codename=market_page&limit=1";
const apiSolution = "?system.codename=solutions_page&limit=1";
const apiContact = "?system.type=contact_page";
const apiCareers = "?system.type=careers_page";
const apiAgency = "?system.type=agency_page";
const apiHealthCare = "?system.type=health_care_page";
const apiLottery = "?system.type=lottery_page";
const apiSuperbowl = "?system.type=superbowl_page";
const apiADforum = "?system.type=adforum_2022_page";
const apiTestPage = "?system.type=test";
const apiPages = "?system.type=pages";
const apiFirstPartyData = "?system.type=first_party_data_page";

const apiIDEA = "?system.type=idea_page";
const apiMonthlyTopics = "?system.type=monthly_topics&limit=4";
const apiInclusion = "?system.type=inclusion_detail";
// const apiInclusionPage = "?system.type=inclusion"; // TODO CHANGE LIVE
const apiInclusionPage = "?system.type=diversity";
const apiInclusionCaseStudies = "?system.codename=inclusion_case_studies&limit=1";
//items
const apiCaseStudy = "?system.type=case_study";
const apiArticles = "?system.type=article";
const apiExpertise = "?system.type=expertise";
const apiMarkets = "?system.type=market_detail";

const apiSolutions = "?system.type=solution_detail";
const apiDiversity = "?system.type=diversity";
const apiContactItems = "?system.type=contact_information";

//taxonomy
const apiTaxonomySolutions = "https://deliver.kenticocloud.com/010f24d6-49bf-4ff0-a1a8-ba951cc97376/taxonomies?system.codename=solutions_categories";
const apiTaxonomyMarkets = "https://deliver.kenticocloud.com/010f24d6-49bf-4ff0-a1a8-ba951cc97376/taxonomies?system.codename=market_categories";
const apiTaxonomyCategories = "https://deliver.kenticocloud.com/010f24d6-49bf-4ff0-a1a8-ba951cc97376/taxonomies?system.codename=word_category";

//modules
const apiAuthor = "?system.type=author__for_blog_post_&system.codename=";
const apiQuotes = "?system.codename=";
const apiError = "?system.type=error_pages";
const apiTerms = "?system.type=terms___conditions";
const apiCodeOfConduct = "?system.type=code_of_conducts";
const apiPrivacy = "?system.type=privacy_policy";

function containsObject(obj, list) {
  var i;
  for (i = 0; i < list.length; i++) {
    if (list[i].system.id === obj.system.id) {
      return true;
    }
  }
  return false;
}

function srvTime() {
  try {
    //FF, Opera, Safari, Chrome
    xmlHttp = new XMLHttpRequest();
  } catch (err1) {
    //IE
    try {
      xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
    } catch (err2) {
      try {
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      } catch (eerr3) {
        //AJAX not supported, use CPU time.
        alert("AJAX not supported");
      }
    }
  }
  // xmlHttp.open('HEAD', window.location.host, false);
  xmlHttp.open("HEAD", window.location.host);
  xmlHttp.setRequestHeader("Content-Type", "text/html");
  //xmlHttp.send('');
  return new Date(xmlHttp.getResponseHeader("Date"));
}

function addSeoHead(_this, response, page_title) {
  let self = _this;

  if (response.seo_title_page.value != "") {
    self.seo_title = response.seo_title_page.value;
    self.page_title = response.seo_title_page.value;
  } else {
    self.page_title = page_title;
  }
  if (response.seo_description_page.value != "") {
    self.seo_description = response.seo_description_page.value;
  }
  if (response.seo_keywords.value != "") {
    self.seo_keywords = response.seo_keywords.value;
  }

  if (typeof response.header_text != "undefined") {
    if (response.header_text.value != "") {
      self.og_title = response.header_text.value;
    }
  } else {
    if (response.header_title.value != "") {
      self.og_title = response.header_title.value;
    }
  }

  if (typeof response.background_image___mobile != "undefined") {
    if (response.background_image___mobile.value != "") {
      self.og_image = response.background_image___mobile.value[0].url;
    }
  } else {
    if (typeof response.header_text != "undefined") {
      if (response.header_text.value != "") {
        self.og_image = response.header_text.value;
      }
    } else {
      if (
        typeof response.thumbnail_image != "undefined" &&
        response.thumbnail_image.value != ""
      ) {
        self.og_image = response.thumbnail_image.value[0].url;
      }
    }
  }

  self.og_url = window.location.href;

  self.$emit("updateHead");
  setTimeout(function () {
    $("#footer").show();
  }, 500);
}

module.exports = {
  methods: {
    escapeHtmlEntities: function (text) {
      var entityTable = {
        169: "copy",
        174: "reg",
        240: "eth",
        8482: "trade",
      };

      return text.replace(/[\u00A0-\u2666<>\&]/g, function (c) {
        if (entityTable.hasOwnProperty([c.charCodeAt(0)])) {
          return (
            '<sup class="sup">&' +
            (entityTable[c.charCodeAt(0)] || "#" + c.charCodeAt(0)) +
            ";</sup>"
          );
        } else return c;
      });
    },
    async getHome() {
      // this.$http.get(apiKentico + '?elements.insights_list[any]=no&limit=1' ).then((res)=>{
      //   console.log('----->>>>', res);
      //   alert();
      //   let insightList = this.pageHome.elements.work.value;
      //   if(insightList.length){
      //     for (var insight in insightList) {
      //       if (this.modularContent.hasOwnProperty(insightList[insight])) {
      //         this.insightList.push(this.modularContent[insightList[insight]]);
      //       }
      //     }
      //   }
      // });

      await this.$http.get(apiKentico + apiHome,objPreview).then((response) => {
        this.pageHome = response.body.items[0];
        this.modularContent = response.body.modular_content;

        let works = this.pageHome.elements.work.value;
        if (works.length) {
          for (var work in works) {
            if (this.modularContent.hasOwnProperty(works[work])) {
              this.works.push(this.modularContent[works[work]]);
            }
          }
        }

        let words = this.pageHome.elements.word.value;
        if (words.length) {
          for (var word in words) {
            if (this.modularContent.hasOwnProperty(words[word])) {
              this.words.push(this.modularContent[words[word]]);
            }
          }
        }

        addSeoHead(this, response.body.items[0].elements, "Home");
      });
    },
    getVideoSlider: function (videos) {
      for (var i in videos) {
        this.$http
          .get(apiKentico + "?system.codename=" + videos[i])
          .then((response) => {
            this.arrVideos.push(response.body.items[0].elements);
          });
      }
    },
    async getWorks(limit, taxonomyExclude) { // taxonomyExclude = if you need extra query in your call.

      var taxSolList = [];

      await this.$http.get(apiTaxonomySolutions,objPreview).then(res => {
        taxSolutions = res.body.taxonomies[0].terms;
        if (taxSolutions.length) {
          for (var i in taxSolutions) {
            if (taxonomyExclude != undefined && taxSolutions[i].codename == taxonomyExclude) {
              // taxSolList.push(taxSolutions[i].codename); 
            } else {
              taxSolList.push(taxSolutions[i].codename);
            }
            
          }
        }
      }).then(res => {
        this.$http.get(apiKentico + apiWork,objPreview).then((response) => {
          if (response.body.items[0].elements.related_work_description.value) {
            this.relatedText = response.body.items[0].elements.related_work_description.value;
          }
        });

        this.$http.get(apiKentico + apiCaseStudy + "&elements.solutions__for_work_[any]=" + taxSolList.join(',') + "&order=system.last_modified[desc]&limit=" + limit,objPreview)
          .then((response) => {
            this.works = response.body.items;
            this.modularContent = response.body.modular_content;
          });
      });
    },
    async getWork() {
      await this.$http.get(apiKentico + apiWork,objPreview).then((response) => {
        this.pageWork = response.body.items[0].elements;
        addSeoHead(this, response.body.items[0].elements, "Work");
      });
    },
    async filterWorks(by) {
      await this.$http.get(apiKentico + apiCaseStudy + "&order=system.last_modified[desc]" + by,objPreview)
        .then((response) => {
          this.works = response.body.items;
        });
    },
    getWord: function () {
      this.$http.get(apiKentico + apiWord,objPreview).then((response) => {
        this.pageWord = response.body.items[0].elements;
        addSeoHead(this, response.body.items[0].elements, "Words");
      });
    },
    getSolution: function (notDetailPage) {
      this.$http.get(apiKentico + apiSolution,objPreview).then((response) => {
        this.pageSolution = response.body.items[0].elements;
        if (notDetailPage)
          addSeoHead(this, response.body.items[0].elements, "Solutions");
      });
    },
    getSolutionById: function (id) {
      this.$http.get(apiKentico + "?system.codename=" + id,objPreview).then((response) => {
        if (response.body.items.length)
          this.solutions.push(response.body.items[0]);
      });
    },
    getMarket: function (notDetailPage) {
      this.$http.get(apiKentico + apiMarket,objPreview).then((response) => {
        this.pageMarket = response.body.items[0].elements;
        if (notDetailPage)
          addSeoHead(this, response.body.items[0].elements, "Markets");
      });
    },
    getAgency: function () {
      this.$http.get(apiKentico + apiAgency,objPreview).then((response) => {
        this.pageAgency = response.body.items[0];
        this.modularContent = response.body.modular_content;

        let sliders = this.pageAgency.elements.timeline_items.value;
        if (sliders.length) {
          for (var slider in sliders) {
            if (this.modularContent.hasOwnProperty(sliders[slider])) {
              this.sliders.push(this.modularContent[sliders[slider]].elements);
            }
          }
        }

        let leaders = this.pageAgency.elements.team_members_06a134b.value;
        if (leaders.length) {
          for (var lead in leaders) {
            if (this.modularContent.hasOwnProperty(leaders[lead])) {
              this.leaders.push(this.modularContent[leaders[lead]].elements);
            }
          }
        }

        let team_members = this.pageAgency.elements.team_members.value;
        if (team_members.length) {
          for (var helm in team_members) {
            if (this.modularContent.hasOwnProperty(team_members[helm])) {
              this.helm.push(this.modularContent[team_members[helm]].elements);
            }
          }
        }

        let related = this.pageAgency.elements.related_words.value;
        if (related.length) {
          for (var article in related) {
            if (this.modularContent.hasOwnProperty(related[article])) {
              this.relatedArticles.push(this.modularContent[related[article]]);
            }
          }
        }

        let quot = this.pageAgency.elements.quote.value;
        if (quot.length) {
          if (this.modularContent.hasOwnProperty(quot)) {
            this.quote = this.modularContent[quot];
          }
        }

        addSeoHead(this, response.body.items[0].elements, "Agency");
      });
    },
    getIDEA: function () {
      this.$http.get(apiKentico + apiIDEA,objPreview).then((response) => {
        
        this.pageIDEA = response.body.items[0];
        this.modularContent = response.body.modular_content;

        // let sliders = this.pageIDEA.elements.slider_section.value;
        // if(sliders.length){
        //   for (var slider in sliders) {
        //     if (this.modularContent.hasOwnProperty(sliders[slider])) {
        //       this.sliders.push(this.modularContent[sliders[slider]].elements);
        //     }
        //   }
        // }

        let team = this.pageIDEA.elements.team.value;
        if (team.length) {
          for (var member in team) {
            if (this.modularContent.hasOwnProperty(team[member])) {
              this.team.push(this.modularContent[team[member]].elements);
            }
          }
        }

        let related = this.pageIDEA.elements.related_words.value;
        if (related.length) {
          for (var article in related) {
            if (this.modularContent.hasOwnProperty(related[article])) {
              this.relatedArticles.push(this.modularContent[related[article]]);
            }
          }
        }

        let related_works = this.pageIDEA.elements.related_works.value;
        if (related_works.length) {
          for (var article in related_works) {
            if (this.modularContent.hasOwnProperty(related_works[article])) {
              this.relatedWorks.push(
                this.modularContent[related_works[article]]
              );
            }
          }
        }

        addSeoHead(this, response.body.items[0].elements, "Diversity");
      });
    },

    getCaseStudy: function (url) {
      this.$http
        .get(apiKentico + apiCaseStudy + "&elements.url=" + url)
        .then((response) => {
          if (!response.body.items.length) {
            this.$router.push("/404");
            return;
          }
          this.pageData = response.body.items[0];
          this.modularContent = response.body.modular_content;
          this.pageData.elements.case_study_description.value =
            this.escapeHtmlEntities(
              response.body.items[0].elements.case_study_description.value
            );

          // get selected related
          // get related by client
          // get related by last modified

          let solutions = this.pageData.elements.solutions.value;
          if (solutions.length) {
            for (var solut in solutions) {
              if (this.modularContent.hasOwnProperty(solutions[solut])) {
                this.solutions.push(
                  this.modularContent[solutions[solut]].elements
                );
              }
            }
          }

          let limitOfItems = 4;
          let current_works = [];
          let related_works = this.pageData.elements.related_work.value;
          if (related_works.length) {
            for (var article in related_works) {
              if (this.modularContent.hasOwnProperty(related_works[article])) {
                this.relatedWorks.push(
                  this.modularContent[related_works[article]]
                );
                current_works.push(related_works[article]);
              }
            }

            current_works.push(response.body.items[0].system.codename);
          }

          limitOfItems -= related_works.length;
          if (limitOfItems > 0) {
            this.$http
              .get(
                apiKentico +
                "?system.type=case_study&order=system.last_modified[desc]&limit=5"
              )
              .then((response) => {
                for (var i = 0; i < response.body.items.length; i++) {
                  if (
                    current_works.indexOf(
                      response.body.items[i].system.codename
                    ) == -1
                  ) {
                    this.relatedWorks.push(response.body.items[i]);
                  }
                }

                limitOfItems -= response.body.items.length;
                if (limitOfItems > 0) {
                  let others = [];
                  this.$http
                    .get(
                      apiKentico +
                      "?system.type=case_study&order=system.last_modified[desc]&limit=5"
                    )
                    .then((response) => {
                      // save others
                      for (var j = 0; j < response.body.items.length; j++) {
                        others.push(response.body.items[j]);
                      }
                      // check if they exists
                      for (var i = 0; i < others.length; i++) {
                        if (!containsObject(others[i], this.relatedWorks))
                          this.relatedWorks.push(others[i]);
                      }
                    });
                }
              });
          }

          let sliders = this.pageData.elements.slider_video.value;
          if (sliders.length) {
            for (var slide in sliders) {
              if (this.modularContent.hasOwnProperty(sliders[slide])) {
                this.sliders.push(this.modularContent[sliders[slide]].elements);
              }
            }
          }

          this.pageData.elements.video_slider = this.sliders;
          addSeoHead(this, response.body.items[0].elements, "Work");
        });
    },
    replaceContentElement(elements, modularContent) {
      var content = document.createElement("div");
      content.innerHTML = elements;

      var objects = content.getElementsByTagName("object");
      var items = objects.length;

      for (var i = 0; i < items; i++) {
        var elem = content.getElementsByTagName("object")[0];

        if (modularContent.hasOwnProperty(elem.getAttribute("data-codename"))) {
          var ce = modularContent[elem.getAttribute("data-codename")];

          if (ce.system.type == "image_container") {
            var new_element = document.createElement("img");
            new_element.setAttribute("src", ce.elements.image.value[0].url);
            new_element.setAttribute(
              "class",
              "float_" + ce.elements.aligment.value[0].codename
            );
            new_element.setAttribute(
              "alt",
              ce.elements.alternate_text.value[0].codename
            );
          }

          if (ce.system.type == "quote") {
            var new_element = document.createElement("div");
            new_element.setAttribute("class", "content-quote");

            var quote = document.createElement("div");
            quote.setAttribute("class", "quote-text text-center");
            quote.innerHTML = ce.elements.quote_text.value;

            var author = document.createElement("span");
            author.setAttribute("class", "author");
            author.innerHTML = ce.elements.author.value;
            quote.appendChild(author);

            new_element.appendChild(quote);
          }
          if (ce.system.type == "video") {
            var new_element = document.createElement("div");
            new_element.setAttribute("class", "embed-container");

            var iframe = document.createElement("iframe");
            iframe.setAttribute(
              "src",
              "https://player.vimeo.com/video/" +
              ce.elements.vimeo_id.value +
              "?loop=1&title=0&byline=0&portrait=0&api=1"
            );
            iframe.setAttribute("width", "640");
            iframe.setAttribute("height", "360");
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute("webkitallowfullscreen", "1");
            iframe.setAttribute("mozallowfullscreen", "1");
            iframe.setAttribute("allowfullscreen", "1");
            iframe.setAttribute("allow", "autoplay; fullscreen");

            new_element.appendChild(iframe);
          }
          elem.replaceWith(new_element);
        }
      }
      return content.innerHTML;
    },
    getArticle: function (url) {
      this.$http
        .get(apiKentico + apiArticles + "&elements.url=" + url)
        .then((response) => {
          if (!response.body.items.length) {
            this.$router.push("/404");
            return;
          }
          this.pageData = response.body.items[0];
          this.modularContent = response.body.modular_content;
          this.pageData.elements.main_content.value =
            this.replaceContentElement(
              this.pageData.elements.main_content.value,
              this.modularContent
            );
          this.$http
            .get(
              apiKentico + apiAuthor + this.pageData.elements.author.value[0]
            )
            .then((response) => {
              this.authorData = response.body.items[0];
              this.$http
                .get(
                  apiKentico +
                  apiArticles +
                  "&elements.author[all]=" +
                  this.authorData.system.codename
                )
                .then((response) => {
                  this.relatedArticles = response.body.items;
                });
            });
          addSeoHead(this, response.body.items[0].elements, "Words");
        });
    },
    getArticles: function (limit) {
      this.$http
        .get(
          apiKentico + apiArticles + "&order=elements.date[desc]&limit=" + limit
        )
        .then((response) => {
          this.articles = response.data.items;
        });
    },
    getExpertise: function (url) {
      this.$http
        .get(apiKentico + apiExpertise + "&elements.url=" + url)
        .then((response) => {
          if (!response.body.items.length) {
            this.$router.push("/404");
            return;
          }
          this.pageData = response.body.items[0];
          this.modularContent = response.body.modular_content;
          this.pageData.elements.main_content.value =
            this.replaceContentElement(
              this.pageData.elements.main_content.value,
              this.modularContent
            );

          //console.log(this.pageData.elements.related_articles)

          //  var articles = this.pageData.elements.related_articles.value.join(",");

          let related = this.pageData.elements.related_articles.value;
          if (related.length) {
            for (var article in related) {
              if (this.modularContent.hasOwnProperty(related[article])) {
                this.relatedArticles.push(
                  this.modularContent[related[article]]
                );
              }
            }
          }

          let resources = this.pageData.elements.resources.value;
          if (resources.length) {
            for (var res in resources) {
              if (this.modularContent.hasOwnProperty(resources[res])) {
                this.resources.push(this.modularContent[resources[res]]);
              }
            }
          }

          // this.$http.get(apiKentico + apiArticles + '&elements.url=' + articles).then( (response) => {
          //   this.relatedArticles = response.body.items;
          // })

          addSeoHead(this, response.body.items[0].elements, "Expertise");
        });
    },
    getHealthCare: function () {
      this.$http.get(apiKentico + apiHealthCare,objPreview).then((response) => {
        let formInfo = response.body.items[0].elements.contact_form.value[0];

        this.pageHealthCare = response.body.items[0];
        this.modularContent = response.body.modular_content;
        this.contactFormInfo = response.body.modular_content[formInfo].elements;

        addSeoHead(this, response.body.items[0].elements, "Health Care");
      });
    },
    getFirstPartyData: function () {
      this.$http.get(apiKentico + apiFirstPartyData,objPreview).then((response) => {
        let formInfo = response.body.items[0].elements.contact_form.value[0];

        this.pageFirstPartyData = response.body.items[0];
        this.modularContent = response.body.modular_content;
        this.contactFormInfo = response.body.modular_content[formInfo].elements;

        addSeoHead(this, response.body.items[0].elements, "First Party Data");
      });
    },
    getLottery: function () {
      this.$http.get(apiKentico + apiLottery,objPreview).then((response) => {
        let formInfo = response.body.items[0].elements.contact_form.value[0];

        this.pageLottery = response.body.items[0];
        this.modularContent = response.body.modular_content;
        this.contactFormInfo = response.body.modular_content[formInfo].elements;

        let sliders = this.pageLottery.elements.cases.value;
        if (sliders.length) {
          for (var slider in sliders) {
            if (this.modularContent.hasOwnProperty(sliders[slider])) {
              this.sliders.push(this.modularContent[sliders[slider]].elements);
            }
          }
        }

        addSeoHead(this, response.body.items[0].elements, "Lottery");
      });
    },
    getSuperbowl: function (codename) {
      this.$http.get(apiKentico + apiSuperbowl + '&system.codename=' + codename  , objPreview).then((response) => {
        if (response.body.items.length == 0) {
          this.$router.push("404");
        }

        let formInfo = response.body.items[0].elements.contact_form.value[0];

        this.pageSuperbowl = response.body.items[0];
        this.modularContent = response.body.modular_content;
        this.contactFormInfo = response.body.modular_content[formInfo].elements;

        let sliders = this.pageSuperbowl.elements.slider.value;
        if (sliders.length) {
          for (var slider in sliders) {
            if (this.modularContent.hasOwnProperty(sliders[slider])) {
              this.sliders.push(this.modularContent[sliders[slider]].elements);
            }
          }
        }

        addSeoHead(this, response.body.items[0].elements, "Superbowl");
      });
    },

    getADforum: function () {
      this.$http.get(apiKentico + apiADforum,objPreview).then((response) => {
        if (response.body.items.length == 0) {
          this.$router.push("404");
        }

        let formInfo = response.body.items[0].elements.contact_form.value[0];

        this.pageADforum = response.body.items[0];
        this.modularContent = response.body.modular_content;
        this.contactFormInfo = response.body.modular_content[formInfo].elements;

        let sliders = this.pageADforum.elements.slider.value; 
        
        if (sliders.length) {
          for (var slider in sliders) {
            if (this.modularContent.hasOwnProperty(sliders[slider])) {
              this.sliders.push(this.modularContent[sliders[slider]].elements);
            }
          }
        }

        addSeoHead(this, response.body.items[0].elements, "AdForum 2022");
      });
    },

    getTest: function () {
      this.$http.get(apiKentico + apiTestPage,objPreview).then((response) => {
        //let formInfo = response.body.items[0].elements.contact_form.value[0];

        this.pageTest = response.body.items[0];
        this.modularContent = response.body.modular_content;

        addSeoHead(this, response.body.items[0].elements, "Lottery");
      });
    },
    getBasicPage: function (url) {
      this.$http
        .get(apiKentico + apiPages + "&elements.url=" + url)
        .then((response) => {
          if (!response.body.items.length) {
            this.$router.push("/404");
            return;
          }

          this.basicPage = response.body.items[0];
          this.modularContent = response.body.modular_content;

          addSeoHead(this, response.body.items[0].elements, "Pages");
        });
    },
    filterArticles: function (by) {
      this.$http
        .get(
          apiKentico + apiArticles + "&order=system.last_modified[desc]" + by
        )
        .then((response) => {
          this.articles = response.data.items;
        });
    },
    getMarkets: function (limit) {
      this.$http
        .get(
          apiKentico +
          apiMarkets +
          "&order=system.last_modified[desc]&limit=" +
          limit
        )
        .then((response) => {
          this.markets = response.data.items;
        });
    },
    async getInclusionPage() {
      await this.$http.get(apiKentico + apiInclusionPage,objPreview).then((response) => {        

        this.pageInclusion = response.body.items[0];
        this.modularContent = response.body.modular_content;

        let sliders = this.pageInclusion.elements.slider_section.value;
        if (sliders.length) {
          for (var slider in sliders) {
            if (this.modularContent.hasOwnProperty(sliders[slider])) {
              this.sliders.push(this.modularContent[sliders[slider]].elements);
            }
          }
        }
        let related_works = this.pageInclusion.elements.related_works.value;
        if (related_works.length) {
          for (var article in related_works) {
            if (this.modularContent.hasOwnProperty(related_works[article])) {
              this.relatedWorks.push(
                this.modularContent[related_works[article]]
              );
            }
          }
        }

        let related = this.pageInclusion.elements.related_words.value;
        if (related.length) {
          for (var article in related) {
            if (this.modularContent.hasOwnProperty(related[article])) {
              this.relatedArticles.push(this.modularContent[related[article]]);
            }
          }
        }

        addSeoHead(this, response.body.items[0].elements, "Inclusion");
      });
    },
    async getInclusion(limit) {
      await this.$http
        .get(
          apiKentico +
          apiInclusion +
          "&order=system.last_modified[desc]&limit=" +
          limit
        )
        .then((response) => {
          this.inclusion = response.data.items;
        });
    },
    async getInclusionDetails(url) {
      await this.$http
        .get(apiKentico + apiInclusion + "&elements.url=" + url)
        .then((response) => {
          if (!response.body.items.length) {
            this.$router.push("/404");
            return;
          }

          this.inclusionDetail = response.body.items[0];
          this.modularContent = response.body.modular_content;
          
          let inclusionTaxonomy = JSON.parse(JSON.stringify(this.inclusionDetail.system.codename));
          this.getMonthlyTopics(inclusionTaxonomy);

          let team = this.inclusionDetail.elements.team.value;
          if (team.length && team != undefined) {
            for (var member in team) {
              if (this.modularContent.hasOwnProperty(team[member])) {
                this.team.push(this.modularContent[team[member]].elements);
              }
            }
          }

          let related = this.inclusionDetail.elements.related_words.value;
          if (related.length && related != undefined) {
            for (var article in related) {
              if (this.modularContent.hasOwnProperty(related[article])) {
                this.relatedArticles.push(
                  this.modularContent[related[article]]
                );
              }
            }
          }

          let related_works = this.inclusionDetail.elements.related_works.value;
          if (related_works.length && related_works != undefined) {
            for (var article in related_works) {
              if (this.modularContent.hasOwnProperty(related_works[article])) {
                this.relatedWorks.push(
                  this.modularContent[related_works[article]]
                );
              }
            }
          }

          addSeoHead(this, response.body.items[0].elements, "Inclusion");
        });
    },
    async getMonthlyTopics(inclusionTaxonomy) {
      let futureDate = srvTime();
      let dateString =
        futureDate.getFullYear().toString() + "-" + (futureDate.getMonth() + 1 < 10 ? "0" + (futureDate.getMonth() + 1).toString() : (futureDate.getMonth() + 1).toString()) + "-01";


      await this.$http.get(apiKentico + apiMonthlyTopics + `&elements.inclusion_categories[any]=${inclusionTaxonomy}&elements.date[gt]=${dateString}&order=elements.date[asc]`,objPreview)
        .then((response) => {
          this.monthlyTopics = response.body.items;
        });
    },
    async getInclusionCaseStudies(limit) {
      await this.$http.get(apiKentico + apiInclusionCaseStudies,objPreview).then((response) => {
        this.pageInclusionCaseStudies = response.body.items[0].elements;
        addSeoHead(this, response.body.items[0].elements, "Inclusion");
      });
      await this.$http.get(apiKentico + apiCaseStudy + "&elements.solutions__for_work_[any]=inclusion&order=system.last_modified[desc]&limit=" + limit,objPreview)
        .then((response) => {
          this.caseStudies = response.body.items;
          this.modularContent = response.body.modular_content;
        });
    },
    getMarketDetails: function (url) {
      this.$http
        .get(apiKentico + apiMarkets + "&elements.url=" + url)
        .then((response) => {
          if (!response.body.items.length) {
            this.$router.push("/404");
            return;
          }

          this.marketDetail = response.body.items[0];
          this.modularContent = response.body.modular_content;

          let quote = this.marketDetail.elements.quote.value;
          if (quote.length) {
            if (this.modularContent.hasOwnProperty(quote)) {
              this.quote = this.modularContent[quote];
            }
          }

          let limitOfItems = 4;
          let related_words = this.marketDetail.elements.related_works.value;
          if (related_words.length) {
            for (var article in related_words) {
              if (this.modularContent.hasOwnProperty(related_words[article])) {
                this.relatedWorks.push(
                  this.modularContent[related_words[article]]
                );
              }
            }
          }

          limitOfItems -= related_words.length;
          if (limitOfItems > 0) {
            this.$http
              .get(
                apiKentico +
                apiCaseStudy +
                "&elements.market_categories[all]=" +
                this.marketDetail.elements.market_categories.value[0]
                  .codename +
                "&limit=" +
                limitOfItems
              )
              .then((response) => {
                for (var i = 0; i < response.body.items.length; i++) {
                  this.relatedWorks.push(response.body.items[i]);
                }
                limitOfItems -= response.body.items.length;
                if (limitOfItems > 0) {
                  let others = [];
                  this.$http
                    .get(
                      apiKentico +
                      "?system.type=case_study&order=system.last_modified[desc]&limit=4"
                    )
                    .then((response) => {
                      // save others

                      for (var j = 0; j < response.body.items.length; j++) {
                        others.push(response.body.items[j]);
                      }
                      // check if they exists
                      for (var i = 0; i < others.length; i++) {
                        if (!containsObject(others[i], this.relatedWorks))
                          this.relatedWorks.push(others[i]);
                      }
                    });
                }
              });
          }

          let limitOfArticles = 4;
          let related_articles = this.marketDetail.elements.related_words.value;
          if (related_articles.length) {
            for (var article in related_articles) {
              if (
                this.modularContent.hasOwnProperty(related_articles[article])
              ) {
                this.relatedArticles.push(
                  this.modularContent[related_articles[article]]
                );
              }
            }
          }

          limitOfArticles -= related_articles.length;
          if (limitOfArticles > 0) {
            let others = [];
            this.$http
              .get(
                apiKentico +
                apiArticles +
                "&order=elements.date[desc]&limit=" +
                limitOfArticles
              )
              .then((response) => {
                // save others
                for (var j = 0; j < response.body.items.length; j++) {
                  others.push(response.body.items[j]);
                }
                // check if they exists
                for (var i = 0; i < others.length; i++) {
                  if (!containsObject(others[i], this.relatedArticles))
                    this.relatedArticles.push(others[i]);
                }
              });
          }
          addSeoHead(this, response.body.items[0].elements, "Markets");
        });
    },
    getSolutions: function (limit) {
      this.$http
        .get(
          apiKentico +
          apiSolutions +
          "&order=system.last_modified[desc]&limit=" +
          limit
        )
        .then((response) => {
          this.solutions = response.data.items;
          this.modularContent = response.body.modular_content;
        });
    },
    getSolutionsDetail: function (url) {
      this.$http
        .get(apiKentico + apiSolutions + "&elements.url=" + url)
        .then((response) => {
          if (!response.body.items.length) {
            this.$router.push("/404");
            return;
          }

          let formInfo = response.body.items[0].elements.contact_form.value[0];

          this.solutionDetail = response.body.items[0];
          this.modularContent = response.body.modular_content;
          this.contactFormInfo =
            response.body.modular_content[formInfo].elements;

          let approachs = this.solutionDetail.elements.approach.value;
          if (approachs.length) {
            for (var approach in approachs) {
              if (this.modularContent.hasOwnProperty(approachs[approach])) {
                this.approachs.push(
                  this.modularContent[approachs[approach]].elements
                );
              }
            }
          }

          let quot = this.solutionDetail.elements.quote.value;
          if (quot.length) {
            if (this.modularContent.hasOwnProperty(quot)) {
              this.quote = this.modularContent[quot];
            }
          }

          let related = this.solutionDetail.elements.related_work.value;
          if (related.length) {
            for (var related_work in related) {
              if (this.modularContent.hasOwnProperty(related[related_work])) {
                this.relatedWorks.push(
                  this.modularContent[related[related_work]]
                );
              }
            }
          }

          let related_articles =
            this.solutionDetail.elements.related_words.value;
          if (related_articles.length) {
            for (var related_articles_groups in related_articles) {
              if (
                this.modularContent.hasOwnProperty(
                  related_articles[related_articles_groups]
                )
              ) {
                this.relatedArticles.push(
                  this.modularContent[related_articles[related_articles_groups]]
                );
              }
            }
          }

          addSeoHead(this, response.body.items[0].elements, "Solutions");
        });
    },
    getAgencySubpages: function (limit) {
      this.$http
        .get(
          apiKentico +
          apiDiversity +
          "&order=system.last_modified[desc]&limit=" +
          limit
        )
        .then((response) => {
          this.agency_subpages = response.data.items;

          // Add IDEA or another subpages agency
          // this.$http.get(apiKentico + apiIDEA + '&order=system.last_modified[desc]&limit='+limit).then((response) => {
          //   this.agency_subpages =  agency_subpages.concat(response.data.items);
          //   console.log(this.agency_subpages);
          //
          // })
        });
    },
    getContact: function () {
      this.$http.get(apiKentico + apiContact,objPreview).then((response) => {
        this.pageContact = response.body.items[0];
        this.modularContent = response.body.modular_content;

        /*
        let contact_information = this.pageContact.elements.contact_information.value;
        for (var i = 0 ; i < contact_information.length; i++) {
          this.$http.get(apiKentico + '?system.codename='+ contact_information[i]).then((response) => {
            this.pageContactItems.push(response.body.items[0].elements)
          })
        }
        */

        let contact_information =
          this.pageContact.elements.contact_information.value;
        if (contact_information.length) {
          for (var contact in contact_information) {
            if (
              this.modularContent.hasOwnProperty(contact_information[contact])
            ) {
              this.pageContactItems.push(
                this.modularContent[contact_information[contact]].elements
              );
            }
          }
        }

        addSeoHead(this, response.body.items[0].elements, "Contact");
      });
    },
    getTaxonomySolutions: function (defaultTitle) {
      this.$http.get(apiTaxonomySolutions,objPreview).then((response) => {
        this.taxonomySolutions = response.body.taxonomies[0].terms;

        if (defaultTitle) {
          this.selectedSolutionTitle = this.taxonomySolutions.find(
            (elem) => elem.codename === defaultTitle
          ).name;
        }
      });
    },
    getTaxonomyMarkets: function (defaultTitle) {
      this.$http.get(apiTaxonomyMarkets,objPreview).then((response) => {
        this.taxonomyMarkets = response.body.taxonomies[0].terms;

        if (defaultTitle) {
          this.selectedMarketTitle = this.taxonomyMarkets.find(
            (elem) => elem.codename === defaultTitle
          ).name;
        }
      });
    },
    getTaxonomyCategories: function () {
      this.$http.get(apiTaxonomyCategories,objPreview).then((response) => {
        this.taxonomyCategories = response.body.taxonomies[0].terms;
      });
    },
    getErrorsPage: function () {
      this.$http.get(apiKentico + apiError,objPreview).then((response) => {
        this.errorPage = response.body.items;
      });
    },
    getTerms: function () {
      this.$http.get(apiKentico + apiTerms,objPreview).then((response) => {
        this.terms = response.body.items[0].elements.html.value;
        addSeoHead(this, response.body.items[0].elements, "Marketing Solutions | Integrated Advertising Agency | Marcus Thomas LLC");
      });
    },
    getCodeOfConduct: function () {
      this.$http.get(apiKentico + apiCodeOfConduct,objPreview).then((response) => {
        this.terms = response.body.items[0].elements.html.value;
        addSeoHead(this, response.body.items[0].elements, "Marketing Solutions | Integrated Advertising Agency | Marcus Thomas LLC");
      });
    },
    getPrivacy: function () {
      this.$http.get(apiKentico + apiPrivacy,objPreview).then((response) => {
        this.privacy = response.body.items[0].elements.html.value;
      });
    },
    getCareers: function () {
      this.$http.get(apiKentico + apiCareers,objPreview).then((response) => {
        this.pageCareers = response.body.items[0];
        this.modularContent = response.body.modular_content;

        let sliders = this.pageCareers.elements.slider_images.value;
        if (sliders.length) {
          for (var slider in sliders) {
            if (this.modularContent.hasOwnProperty(sliders[slider])) {
              this.careersSliders.push(
                this.modularContent[sliders[slider]].elements
              );
            }
          }
        }

        let quot = this.pageCareers.elements.quote.value;
        if (quot.length) {
          if (this.modularContent.hasOwnProperty(quot)) {
            this.quote = this.modularContent[quot];
          }
        }

        let related_words = this.pageCareers.elements.related_words.value;
        if (related_words.length) {
          for (var article in related_words) {
            if (this.modularContent.hasOwnProperty(related_words[article])) {
              this.relatedWorks.push(
                this.modularContent[related_words[article]]
              );
            }
          }
        }

        let v_sliders = this.pageCareers.elements.slider_video.value;

        if (v_sliders.length) {
          for (var slide in v_sliders) {
            if (this.modularContent.hasOwnProperty(v_sliders[slide])) {
              this.videosSliders.push(
                this.modularContent[v_sliders[slide]].elements
              );
            }
          }
        }
        addSeoHead(this, response.body.items[0].elements, "Careers");
      });
    },
    getCX2: function () {
      this.$http.get("/cx_2.json").then((response) => {
        this.pageHome = response.body.items[0];
        this.modularContent = response.body.modular_content;

        let works = this.pageHome.elements.work.value;
        if (works.length) {
          for (var work in works) {
            if (this.modularContent.hasOwnProperty(works[work])) {
              this.works.push(this.modularContent[works[work]]);
            }
          }
        }
        let words = this.pageHome.elements.word.value;
        if (words.length) {
          for (var word in words) {
            if (this.modularContent.hasOwnProperty(words[word])) {
              this.words.push(this.modularContent[words[word]]);
            }
          }
        }
        addSeoHead(this, response.body.items[0].elements, "CX2");
      });
    },
    getDoItWithMe: function () {
      this.$http.get("/doitwithme_2.json").then((response) => {
        this.pageHome = response.body.items[0];
        this.modularContent = response.body.modular_content;

        let works = this.pageHome.elements.work.value;
        if (works.length) {
          for (var work in works) {
            if (this.modularContent.hasOwnProperty(works[work])) {
              this.works.push(this.modularContent[works[work]]);
            }
          }
        }
        let words = this.pageHome.elements.word.value;
        if (words.length) {
          for (var word in words) {
            if (this.modularContent.hasOwnProperty(words[word])) {
              this.words.push(this.modularContent[words[word]]);
            }
          }
        }
        addSeoHead(this, response.body.items[0].elements, "Do it With Me");
      });
    },
    //BigWebtoolBox
    BigWebtoolBox: function () {
      this.$http.get("/bigwebtoolbox_data.json").then((response) => {
        this.pageHome = response.body.items[0];
        this.modularContent = response.body.modular_content;

        let works = this.pageHome.elements.work.value;
        if (works.length) {
          for (var work in works) {
            if (this.modularContent.hasOwnProperty(works[work])) {
              this.works.push(this.modularContent[works[work]]);
            }
          }
        }
        let words = this.pageHome.elements.word.value;
        if (words.length) {
          for (var word in words) {
            if (this.modularContent.hasOwnProperty(words[word])) {
              this.words.push(this.modularContent[words[word]]);
            }
          }
        }
        addSeoHead(this, response.body.items[0].elements, "Big Web Toolbox");
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/apiConnection.js